import { ArrowRight, Check } from "lucide-react";
import { DIVISIONS } from "../../data/content";
import { FadeUp, ChapterTag } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

export default function Divisions() {
    return (
        <section className="bg-navy-deep py-24 lg:py-32" data-testid="divisions-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag>Chapter 01 &mdash; Two Divisions, One Group</ChapterTag>

                <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
                    {DIVISIONS.map((d, i) => (
                        <FadeUp key={d.id} delay={i * 0.12}>
                            <article
                                id={d.id}
                                data-testid={`division-panel-${d.testid}`}
                                className="group relative flex h-full scroll-mt-28 flex-col overflow-hidden border border-white/8 bg-navy-surface transition-colors duration-500 hover:border-gold/40"
                            >
                                <span
                                    className="absolute left-0 top-0 z-10 h-[2px] w-full origin-left scale-x-0 bg-gold transition-transform duration-700 group-hover:scale-x-100"
                                    aria-hidden="true"
                                />
                                <div className="relative h-60 overflow-hidden lg:h-72">
                                    <img
                                        src={d.image}
                                        alt={d.imageAlt}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.06]"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-navy-surface via-navy-deep/30 to-transparent" aria-hidden="true" />
                                    <span className="absolute right-6 top-5 font-serif text-6xl font-light text-outline-gold" aria-hidden="true">
                                        {d.index}
                                    </span>
                                </div>

                                <div className="flex flex-1 flex-col p-8 lg:p-10">
                                    <span className="text-[11px] font-semibold uppercase tracking-[0.34em] text-gold">
                                        Division {d.index}
                                    </span>
                                    <h3 className="mt-4 font-serif text-3xl font-light leading-tight text-ivory lg:text-4xl">
                                        {d.title}
                                    </h3>
                                    <p className="mt-4 text-base leading-relaxed text-slate-300/85">{d.copy}</p>

                                    <ul className="mt-7 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2">
                                        {d.points.map((p) => (
                                            <li key={p} className="flex items-start gap-2.5 text-sm text-slate-300/80">
                                                <Check size={14} className="mt-0.5 shrink-0 text-gold" aria-hidden="true" />
                                                {p}
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="mt-auto pt-9">
                                        <button
                                            type="button"
                                            data-testid={`division-cta-${d.testid}`}
                                            onClick={() => scrollToId(d.ctaTarget)}
                                            className="group/btn inline-flex items-center gap-3 border border-gold/50 px-6 py-3.5 text-xs font-bold uppercase tracking-[0.18em] text-gold transition-colors duration-300 hover:bg-gold hover:text-navy-deep"
                                        >
                                            {d.cta}
                                            <ArrowRight size={14} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
                                        </button>
                                    </div>
                                </div>
                            </article>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
